/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnumItem4
 */
export interface EnumItem4 {
    /**
     * 编码
     * @type {number}
     * @memberof EnumItem4
     */
    code?: number;
    /**
     * 枚举标识名
     * @type {string}
     * @memberof EnumItem4
     */
    enumName?: string;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof EnumItem4
     */
    name?: string;
}

/**
 * Check if a given object implements the EnumItem4 interface.
 */
export function instanceOfEnumItem4(value: object): value is EnumItem4 {
    return true;
}

export function EnumItem4FromJSON(json: any): EnumItem4 {
    return EnumItem4FromJSONTyped(json, false);
}

export function EnumItem4FromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumItem4 {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'enumName': json['enumName'] == null ? undefined : json['enumName'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function EnumItem4ToJSON(json: any): EnumItem4 {
    return EnumItem4ToJSONTyped(json, false);
}

export function EnumItem4ToJSONTyped(value?: EnumItem4 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'enumName': value['enumName'],
        'name': value['name'],
    };
}

